import { memo } from 'react';
import type {
  PropsWithChildren,
  ReactElement,
} from 'react';

import {
  Button,
  buttonColors,
} from '../Button';
import type {
  ButtonColor,
  ButtonSize,
} from '../Button';

import { useRemoveButton } from '../useRemoveButton';
import type {
  UseRemoveButtonParams,
} from '../useRemoveButton';

export type RemoveButtonProps = UseRemoveButtonParams & PropsWithChildren<{
  /**
   * Выключена ли кнопка
   */
  disabled?: boolean;
  /**
   * Цвет кнопки
   */
  color?: ButtonColor;
  /**
   * Размер кнопки
   */
  size?: ButtonSize;
}>;

function RemoveButtonInner({
  children = undefined,
  disabled = false,
  color = undefined,
  size = undefined,
  remove,
  onRemoveSuccess = undefined,
  approveTitle = undefined,
  approveContent = undefined,
  approveButtonText,
  approveButtonColor = buttonColors.DANGER,
  cancelButtonText,
  errorsPath = 'response.data.detail',
  redirectTo = undefined,
  notification = undefined,
}: RemoveButtonProps): ReactElement {
  const {
    isRemoving,
    onClick,
  } = useRemoveButton({
    remove,
    onRemoveSuccess,
    approveTitle,
    approveContent,
    approveButtonText,
    approveButtonColor,
    cancelButtonText,
    errorsPath,
    redirectTo,
    notification,
  });

  return (
    <Button
      componentProps={{
        type: 'button',
      }}
      disabled={disabled || isRemoving}
      onClick={onClick}
      color={color}
      size={size}
    >
      {children}
    </Button>
  );
}

export const RemoveButton = memo(RemoveButtonInner);
